import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import LakeBaikal from "../assets/img/Blogs/Russia/LakeBaikal.jpg";
import Moscow from "../assets/img/Blogs/Russia/Moscow.jpg";
import Murmansk from "../assets/img/Blogs/Russia/Murmansk.jpg";
import SaintPetersburg from "../assets/img/Blogs/Russia/SaintPetersburg.jpg";
import TheTransSiberianRailway from "../assets/img/Blogs/Russia/TheTransSiberianRailway.jpg";

const Russia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap russiaBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Russia</h2>
                  <p>
                    Russia, the world’s largest country, spans two continents
                    and offers a dramatic blend of imperial cities, ancient
                    traditions, and awe-inspiring natural landscapes. From
                    onion-domed cathedrals to frozen tundras, here are the top 5
                    places every traveler should experience in Russia.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={Moscow} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2> Moscow</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Golden domes, grand streets, and echoes of history.</p>
                  </div>
                  <p>
                    Russia’s capital is a powerful mix of history, politics, and
                    architecture. Wander through Red Square, shop in GUM, and
                    marvel at Soviet-era monuments. At night, the city glows
                    with modern lights and world-class nightlife. Try authentic
                    Russian dishes like borscht and pelmeni.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        St. Basil’s Cathedral - the colorful icon of Russian
                        architecture.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={SaintPetersburg} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Saint Petersburg</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>Imperial grace, winding canals, and timeless culture.</p>
                  </div>
                  <p>
                    Often called the “Venice of the North,” this imperial city
                    boasts canals, palaces, and fine art. Founded by Peter the
                    Great, it’s rich in history and baroque elegance. Visit in
                    summer for the “White Nights” – endless daylight and
                    cultural festivals. Ideal for lovers of classical music,
                    ballet, and museums.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        The Hermitage Museum - one of the world’s largest and
                        most prestigious art collections.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={LakeBaikal} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Lake Baikal</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Where ancient waters run deep, and ice and sky stretch
                      into forever.
                    </p>
                  </div>
                  <p>
                    Located in Siberia, this is the deepest and oldest
                    freshwater lake in the world. It holds nearly 20% of the
                    world’s unfrozen freshwater and is stunning year-round. In
                    winter, walk or skate on crystal-clear ice; in summer, hike
                    and swim along its shores. Home to unique flora and fauna,
                    including freshwater seals.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Olkhon Island - a spiritual and scenic heart of Lake
                        Baikal.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img
                    src={TheTransSiberianRailway}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> The Trans-Siberian Railway</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Endless rails, shifting landscapes, and stories across a
                      continent.
                    </p>
                  </div>
                  <p>
                    Not a place but a legendary journey across the breadth of
                    Russia. Stretching over 9,000 km from Moscow to Vladivostok,
                    it’s the world’s longest railway. Travelers witness forests,
                    mountains, villages, and diverse cultures along the way.
                    It’s a once-in-a-lifetime way to see the real Russia.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        The Full Route – the epic experience of crossing 8 time
                        zones.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={Murmansk} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> Murmansk & the Russian Arctic</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Arctic lights, icy silence, and life at the edge of the
                      world.
                    </p>
                  </div>
                  <p>
                    Murmansk is the world’s largest city above the Arctic Circle
                    and a top spot for Northern Lights. Explore polar history,
                    icy landscapes, and experience 24-hour daylight or darkness.
                    Take a trip on a nuclear-powered icebreaker or visit
                    Teriberka on the Barents Sea. Perfect for adventure and
                    cold-weather travel lovers.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Aurora Borealis Viewing – especially vivid in winter
                        months.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={Moscow} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2> Start planning your Russia adventure today!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Russia;
